// Self-hosted fonts: the server's CSP allows fonts from 'self' only, so they
// are bundled rather than fetched from a font CDN. Archivo (Latin) is declared
// in styles/site.css from public/fonts; Malayalam falls back to Noto Sans.
import '@fontsource-variable/noto-sans-malayalam';
import './styles/site.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ScrollToTop } from './components/ScrollToTop';
import { LangProvider } from './i18n';
import { AuthProvider } from './providers/AuthProvider';
import { ToastProvider } from './providers/ToastProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Outermost of the app providers: toasts, auth errors and the router's
          own pages all render text, so the language has to be resolved before
          any of them mount. */}
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AuthProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </AuthProvider>
        </BrowserRouter>
      </LangProvider>
    </QueryClientProvider>
  </StrictMode>,
);
